/**
 * バイト列をファイルとして保存させる（知識ソースの原本、Draft の ZIP）。
 *
 * type は中身の形式にせず octet-stream にする。download 属性が効かない経路で開かれても、
 * 利用者の HTML などを UI のオリジンで描かせないため。
 */
export function saveBytes(bytes: Uint8Array, fileName: string): void {
  // Uint8Array<ArrayBufferLike> は TS 6 の BlobPart に入らないので、ArrayBuffer を持つ複製にする。
  const url = URL.createObjectURL(new Blob([bytes.slice()], { type: 'application/octet-stream' }));
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  // 直後に破棄すると Firefox / Safari でダウンロードが取り消されうるので遅らせる。
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
